import React, { useEffect, useRef } from "react";

interface OwnProps {
    autoScrollIntoView?: boolean;
    autoScrollIntoViewOffset?: number;
}

type Props = OwnProps &
    React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

export const Input: React.FunctionComponent<Props> = React.memo(
    ({ autoFocus, autoScrollIntoView, autoScrollIntoViewOffset, ...rest }) => {
        const ref = useRef<HTMLInputElement>();

        useEffect(() => {
            if (autoFocus && ref.current) {
                ref.current.focus();
            }
        }, [autoFocus]);

        useEffect(() => {
            if (autoScrollIntoView && ref.current) {
                ref.current.scrollIntoView(true);
                if (autoScrollIntoViewOffset) {
                    window.scrollBy(0, autoScrollIntoViewOffset);
                }
            }
        }, [autoScrollIntoView, autoScrollIntoViewOffset]);

        return <input autoFocus={autoFocus} {...rest} ref={ref} />;
    },
);

Input.displayName = "Input";
